import React from 'react';
// import {Link} from 'react-router-dom';
import '../assets/css/404Page.css';

const NotFoundPage = () => {

    return (
        <div id="container404">
            <h2 className="text404">404:Page Not Found!</h2>
            {/* <Link to='/home' /> */}
        </div>
        );
};

export default NotFoundPage;